import React, { useState } from 'react';
import './ShareButton.css';

interface ShareButtonProps {
  roomCode: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ roomCode }) => {
  const [copied, setCopied] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  const shareUrl = `${window.location.origin}/${roomCode}`;
  const shareText = `Join my Photo Blender game! 🎨📸`;

  const handleShare = async () => {
    // Check if Web Share API is available (mobile devices)
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Photo Blender',
          text: shareText,
          url: shareUrl
        });
      } catch (err) {
        // User cancelled or share failed
        console.log('Share cancelled');
      }
    } else {
      // Desktop - show copy options
      setShowOptions(!showOptions);
    }
  };

  const copyToClipboard = async (text: string, type: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        setShowOptions(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="share-button-container">
      <button className="share-button" onClick={handleShare}>
        <span className="share-icon">🔗</span>
        <span className="share-text">Share Room</span>
        <span className="share-glow"></span>
      </button>

      {showOptions && (
        <div className="share-options" onClick={(e) => e.stopPropagation()}>
          <button
            className="share-option"
            onClick={() => copyToClipboard(shareUrl, 'link')}
          >
            <span className="option-icon">📋</span>
            <span className="option-text">Copy Link</span>
          </button>
          <button
            className="share-option"
            onClick={() => copyToClipboard(roomCode, 'code')}
          >
            <span className="option-icon">🔢</span>
            <span className="option-text">Copy Code</span>
          </button>
        </div>
      )}

      {copied && (
        <div className="copied-notification">
          <span>✓ Copied!</span>
        </div>
      )}
    </div>
  );
};

export default ShareButton;
